//import { useDispatch } from "react-redux";
import defaultConfig from "../../config/Config";


const CamelToSentanceCase = function(text = ""){
  if(text){
    const result = text.replace(/([A-Z])/g," $1")
    const finalResult = result.charAt(0).toUpperCase()+result.slice(1)
    return finalResult;
  }else{
    return ''
  }
  
}

const ToSelectOption = function( array = [], keys = { value:"slug", label:"label" }){
  const opt = array.map((item) => { 
    return {"value":item[keys.value], "label": CamelToSentanceCase(item[keys.label])} 
  } )
  return opt
}

const ToSelectOptionGrp = function( obj = [] ){
  for(var value in obj){
    console.log(value)
  }
  // const opt = array.map((item) => { 
  //     return {value:item['slug'], "label":item.label} 
  // } )
  //return opt
}

const getBusinessFormData = function(){
  const businessSaveTmp = JSON.parse(localStorage.getItem("businessSaveTmp"))
  return businessSaveTmp;
}
const GetBusinessData = () => {
  var Business = JSON.parse(localStorage.getItem("SelectedBusiness"));
  // console.log(Business);
  return Business;
} 

const createLedgerGeoup = function(accountHead){
  let groupedAccountHead = [];
  if (typeof accountHead !== "undefined") {
    let optIndex = -1
    groupedAccountHead = accountHead.reduce((acc, curr) => {
      if (acc.length > 0) {
        optIndex = acc.findIndex((item) => item.label === curr.type)
      }
      (optIndex === -1) ?
        acc.push({
          label: curr.type,
          options: [{
            value: curr.id,
            label: curr.title
          }]
        }) : acc[optIndex]["options"].push({
          value: curr.id,
          label: curr.title
        })
      return acc
    }, [])
  }
  return groupedAccountHead;
}

const calculateTimeByHours = function(){
  const todayDate = new Date().getTime()
  const nextDate = todayDate + defaultConfig.tokenExpTime * 1000
  return nextDate; //timestamp
}

const checkAuthExpTime = function(){
  const expDT = JSON.parse(localStorage.getItem("expDT"))
  const currentTime = new Date().getTime()
  return currentTime > expDT;
}

const hasToken = function(){
  const userData = JSON.parse(localStorage.getItem("user"))
  return userData?.token?true:false
} 

const getToken =  function(){
  const userData = JSON.parse(localStorage.getItem("user"))
  return userData?.token  
}

const createAssestsCatGroup = function(assetsGroup){
  let groupedAssets = [];
  if (typeof assetsGroup !== "undefined") {
    let optIndex = -1
    groupedAssets = assetsGroup.reduce((acc, curr) => {
      if (acc.length > 0) {
        optIndex = acc.findIndex((item) => item.label === curr.section)
      }
      (optIndex === -1) ?
        acc.push({
          label: curr.section,
          options: [{
            value: curr.id,
            label: curr.title
          }]
        }) : acc[optIndex]["options"].push({
          value: curr.id,
          label: curr.title
        })
      return acc
    }, [])
  }
  return groupedAssets;
}

const setSelectBoxValue = function(options, value) {
  let selectedVal = value?value.toString():''
  if(!selectedVal || selectedVal === "" ){
    return []
  }

  return options?.find((option) => option.value.toString() === selectedVal)
}

const createFormDataWithFile = (data) =>{        
  let bodyFormData = new FormData() ;
  let filesObjKeys = [];
  for (var key in data) {
      console.log(data[key])
      if((key === 'files') && (typeof data[key] !== 'undefined')){
          filesObjKeys = Object.keys(data[key]);
          for(var i = 0; i <= filesObjKeys.length; i++){
              if(typeof data[key][filesObjKeys[i]] !== 'undefined'){
                 bodyFormData.append(filesObjKeys[i], data[key][filesObjKeys[i]][0]);
              }
         }
      }else {
        bodyFormData.set(key, data[key]);
      }
    }
  return bodyFormData;
}

const toggleSideNav = function () {
  document
    .getElementsByClassName("sidenav-overlay")[0]
    .classList.toggle("show-cls");
  document
    .getElementsByClassName("side-nav")[0]
    .classList.toggle("sidenav-less");
  document
    .getElementsByClassName("main-container")[0]
    .classList.toggle("container-less");
  document
    .getElementsByClassName("header-navbar")[0]
    .classList.toggle("header-less");
  
  const  className = document
    .getElementsByClassName("side-nav")[0]
    .classList.value
  if(className.includes("sidenav-less")){
    localStorage.setItem("GstartSideMenuOpen", true)
  }else{
    localStorage.setItem("GstartSideMenuOpen", false)
  }
};

async function getLocationByLatLang ({lat, lng}){

  return new Promise((resolve, reject) => {
    try{
      if(typeof new window.google.maps.Geocoder() === 'undefined'){
        reject("Google map not loaded")
      }
        const geocoder = new window.google.maps.Geocoder()
        geocoder.geocode({ location: { lat: lat, lng: lng } })
            .then((response) => {
              const place = response.results[0]
              resolve(place)
        })
    }catch(error){
      throw error 
    }
  });  
  
}

function validateLatitude (lat) {
  // check if lat is valid
  return isFinite(lat) && Math.abs(lat) <= 90;
}

function validateLongititu (long) {
  // check if lat is valid
  return isFinite(long) && Math.abs(long) <= 90;
}

function startDownload(file, fileName) {
  const blob = new Blob([file], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
}

function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

function handelResponseError (error) {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    return error?.response?.data;
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    return {message: "Please try after somtime."}
  } else {
    // Something happened in setting up the request that triggered an Error
    return error.message
  }


}

export {
  validateLongititu,
  validateLatitude,
  CamelToSentanceCase,
  ToSelectOptionGrp,
  ToSelectOption,
  getBusinessFormData,
  GetBusinessData,
  createLedgerGeoup,
  calculateTimeByHours,
  checkAuthExpTime,
  hasToken,
  getToken,
  createAssestsCatGroup,
  setSelectBoxValue,
  createFormDataWithFile,
  toggleSideNav,
  getLocationByLatLang,
  startDownload,
  debounce,
  handelResponseError
}
